/* eslint-disable max-len */

export const colors = {
  brand: '#663399',
  lilac: '#9d7cbf',
  accent: '#ffb238',
  success: '#37b635',
  warning: '#ec1818',
  ui: {
    bright: '#e0d6eb',
    light: '#f5f3f7',
    whisper: '#fbfafc'
  },
  code: '#fcf6f0',
  grey: {
    dark: 'hsla(270, 17.119554496%, 0%, 0.92)',
    copy: 'hsla(270, 15.797828016000002%, 0%, 0.77)',
    calm: 'rgba(0, 0, 0, 0.54)'
  },
  white: '#fff',
  black: '#000'
}

export const fonts = {
  sansSerif:
    '"Open Sans Condensed", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", Arial, sans-serif',
  serif: 'Lora, Georgia, "Times New Roman", Times, serif',
  monospace: '"Ubuntu Mono", Lucida Console, Monaco, Menlo, Consolas, "Liberation Mono", "Courier New", monospace'
}

export const breakpoints = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200
}

export const widths = {
  md: 720,
  lg: 960,
  xl: 1140
}

export const dimensions = {
  fontSize: {
    regular: 18,
    large: 22.5
  },
  headingSizes: {
    h1: Math.pow(1.125, 8),
    h2: Math.pow(1.125, 6),
    h3: Math.pow(1.125, 5),
    h4: Math.pow(1.125, 4),
    h5: Math.pow(1.125, 3),
    h6: Math.pow(1.125, 1)
  },
  lineHeight: {
    regular: 1.618,
    heading: 1.2
  },
  containerPadding: 1.5
}

export const heights = {
  header: 60
}
